'use client';

import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link
      href="/privacy#do-not-sell"
      className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors"
      aria-label="Do Not Sell My Personal Information"
    >
      Do Not Sell My Personal Information
    </Link>
  );
}
